/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocsIcon20Light = forwardRef('DocsIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 15V7.378a1.5 1.5 0 0 0-.44-1.06l-3.877-3.879A1.5 1.5 0 0 0 10.622 2H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3ZM7 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V8h-3a2 2 0 0 1-2-2V3H7Zm5 4h2.83L11 3.17V6a1 1 0 0 0 1 1Z" }),
        React.createElement("path", { d: "M18 8.5a.5.5 0 0 0-1 0v7a3.5 3.5 0 0 1-3.5 3.5h-5a.5.5 0 0 0 0 1h5a4.5 4.5 0 0 0 4.5-4.5v-7Z" })));
});
